<template>
    <b-modal id="register-modal" modal-class="account-modal" title="立即注册" hide-footer>
        <div class="modal-bar">
            <b-form>
                <b-form-group label="登录账号" label-align="right" label-cols="3">
                    <b-form-input v-model="registerForm.username" :state="nameValid" placeholder="2-12位,支持中文账户名"/>
                    <b-form-invalid-feedback :state="nameValid">账号名长度应在2-12位之间,允许英文,数字及下划线和中文</b-form-invalid-feedback>
                </b-form-group>
                <repeat-password :state.sync="validPwd" :form="registerForm"/>
                <mobile-coder :form="registerForm" v-show="false"/>
                <b-form-group label-cols="3">
                    <b-button variant="primary" @click="register" :disabled="!valid">立即注册</b-button>
                </b-form-group>
            </b-form>
            <div>
                <p>
                     已有账号？ <a href="javascript:" @click="hideRegisterModal" class="user-pa-btn" v-b-modal:login-modal>立即登录</a>
                </p>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import {openReg} from "@/api/auth/user";
    import {showMessage} from "@/utils";
    import RepeatPassword from "cps/data/RepeatPassword";
    import MobileCoder from "cps/data/MobileCoder";

    const usernamePatten = /^[a-zA-Z0-9\u4e00-\u9fa5_-]{2,12}$/;
    export default {
        name: "RegisterAlert",
        components: {MobileCoder, RepeatPassword},
        data() {
            return {
                registerForm: {
                    username: '',
                    newPassword: '',
                    repeatPassword: '',
                    mobile: '',
                    code: ''
                },
                validPwd: false
            }
        },
        computed: {
            nameValid() {
                return usernamePatten.test(this.registerForm.username);
            },
            valid() {
                return this.nameValid && this.validPwd;
            }
        },
        mounted() {
            this.remember = this.remember_me;
        },
        methods: {
            hideRegisterModal() {
                this.$bvModal.hide('register-modal');
            },
            register() {
                openReg(this.registerForm).then(() => {
                    return showMessage('注册成功');
                }).then(() => {
                    this.hideRegisterModal();
                    this.$bvModal.show('login-modal');
                }).catch(()=>{});
            }
        }
    }
</script>

<style scoped>
</style>
